<template lang='pug'>
vm-card.content-register
  .box-register
    span.text-gray {{ title }}
    span.numbers {{ number }}
</template>

<script>
export default {
  props: {
    number: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    },
    userR: {
      type: Number,
      default: 0
    }
  }
}
</script>
<style lang="scss">
.content-register {
  flex-direction: row;
  .box-register {
    height: 100%;
    background: #fff;
    padding: 10px;
    border-radius: 15px;
    text-align: center;
    display: flex;
    flex-direction: column;
    width: 100%;
    .numbers {
      font-size: 2rem;
      font-weight: 700;
      color: #000;
      padding: 0px 10px;
    }
    .footer-card {
      border-top: .5px solid #a3a3a357;
      padding: 10px 0px 0px 5px;
      .icon-person {
        background: #3AD5FF7A;
        padding: 5px;
        border-radius: 5px;
      }
    }
    .text {
      font-size: 14px;
      color: #2BA5C6;
      padding-left: 10px;
      font-weight: 600;
    }
    .text-gray {
      text-transform: uppercase;
      font-size: 1.2rem;
      color: #2BA5C6;
      padding-left: 10px;
      font-weight: 600;
    }
  }
}

</style>
